import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {ConfirmationService} from 'primeng/primeng';
import {
    AuthorityService,
    ExportService,
    IKeyedCollection,
    JhiAlertComponent,
    KeyedCollection,
    Principal
} from '../../shared';
import {ParametrageService} from '../../entities/parametrage';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'jhi-aide',
    templateUrl: './aide.component.html'
})
export class AideComponent implements OnInit {

    static categorieAide = 'aide';
    currentAccount: any;
    userRolesList: IKeyedCollection<{ nomRole: string, rolePresent: boolean, userRole: boolean, nomFichierAide: string }>
        = new KeyedCollection<any>();
    aidePresente = false;
    error: any;
    success: any;
    private isGestionnaire: boolean;
    maxSize = 10000000;

    private static getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    constructor(private jhiLanguageService: JhiLanguageService,
                private authorityService: AuthorityService,
                private alertService: AlertService,
                private principal: Principal,
                private eventManager: EventManager,
                private parametrageService: ParametrageService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService) {

        this.jhiLanguageService.setLocations(['user-management', 'global', 'aide']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.isGestionnaire = Principal.isAnyAuthorityInListe(['ROLE_GEST', 'ROLE_SYSTEM', 'ROLE_ADMIN'], account.authorities);
            this.loadAll();
        });
    }

    loadAll() {
        this.authorityService.getAllAuthorities().subscribe(
            (res: Response) => this.onSuccess(res.json(), res.headers),
            (res: Response) => this.onError(res)
        );
    }

    supprimeAide(nomRole: string | any) {
        this.confirmationService.confirm({
            message: this.translateService.instant('aide.suppression.message'),
            header: this.translateService.instant('aide.suppression.titre'),
            icon: 'fa fa-trash',
            key: 'confirmAide',
            accept: () => {
                this.parametrageService.suppressFile(AideComponent.categorieAide, nomRole).subscribe(
                    (response: Response) => {
                        this.loadAll();
                    },
                    (response) => {
                        this.onError(response);
                    });

            }
        });
    }

    private onSuccess(roleListe, headers) {
        roleListe.forEach(role => {
            this.userRolesList.Add(role.name, {
                'nomRole': role.name,
                rolePresent: false,
                userRole: false,
                'nomFichierAide': null
            });
        });
        this.determinePresenceAide();
    }

    private onError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    private determinePresenceAide() {
        if (this.currentAccount.authorities != null && this.currentAccount.authorities.length > 0) {
            this.userRolesList.Keys().forEach(authority => {
                if (this.currentAccount.authorities != null &&
                    this.currentAccount.authorities.length > 0 &&
                    (this.isGestionnaire || Principal.isAuthorityInListe(authority.toString(), this.currentAccount.authorities))
                ) {
                    this.userRolesList.Item(authority).rolePresent = true;
                    this.userRolesList.Item(authority).userRole = this.userRolesList.ContainsKey(authority);
                    this.rechercheNomFichierAide(authority);
                }
            });
            // on enleve les roles absents
            if (!this.isGestionnaire) {
                this.userRolesList.Values().forEach(role => {
                    if (role.rolePresent == false) {
                        this.userRolesList.Remove(role.nomRole);
                    }
                });
            }


        }
    }

    private rechercheNomFichierAide(authority) {
        this.parametrageService.getFileName(AideComponent.categorieAide, authority.toString()).subscribe(
            (res: Response) => {
                if (res != null && res.text() != null && res.text().length > 0) {
                    this.userRolesList.Item(authority).nomFichierAide = res.text();
                }
            }
            ,
            (res: Response) => this.onError(res)
        );
    }

    private openAide(role: string) {
        this.parametrageService.getFile(AideComponent.categorieAide, role).subscribe(
            (file: Blob) => {
                ExportService.download(file, role);
            },
            (response) => {
                this.onError(response);
            });
    }

    onFileUploaded(event, userRole) {
        this.rechercheNomFichierAide(userRole);
    }


    // Before the file is sent to the server for upload
    onBeforeUpload(event, user_role) {
        event.formData.append('parametreCategorie', 'aide');
        event.formData.append('parametre', user_role);
    }

    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onBeforeSend(event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', AideComponent.getCookie('XSRF-TOKEN'));
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/aide/aide.component.ts